import { useState } from "react";
import { API_URL } from "../config/endpoints";

export const usePreRegister = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isPreRegistered, setIsPreRegistered] = useState<boolean>(false);

  const preRegister = async (reservationUid: string) => {
    if (!reservationUid) {
      setErrorMessage("Reservation UID is missing.");
      return;
    }

    const apiUrl = `${API_URL}/guest/reservations/${reservationUid}/visual-matrix-pre-registered`;

    setLoading(true);
    setErrorMessage(null);

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Authentication token is missing. Please log in.");
      }

      const response = await fetch(apiUrl, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const status = response.status;
        let userFriendlyMessage =
          "We couldn't complete your pre-registration right now. Please try again.";

        if (status === 400) {
          userFriendlyMessage =
            "Sorry, something isn't right with your pre-registration request. Please try again.";
        } else if (status === 401 || status === 403) {
          userFriendlyMessage =
            "You don't seem to have permission to pre-register. Please check your reservation.";
        } else if (status === 404) {
          userFriendlyMessage =
            "We couldn't find your reservation. Please check your details.";
        } else if (status >= 500) {
          userFriendlyMessage =
            "We're having trouble connecting to our system. Please try again in a moment.";
        }

        setErrorMessage(userFriendlyMessage);
        throw new Error(userFriendlyMessage);
      }

      setIsPreRegistered(true);
    } catch (error) {
      setErrorMessage(
        error instanceof Error ? error.message : "An unexpected error occurred."
      );
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    errorMessage,
    isPreRegistered,
    preRegister,
  };
};
